import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import hazard2 from '../../images/hazard2.png';


import {CSVLink} from "react-csv";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";

class ChecklistQuedas extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.showDiv26= this.showDiv26.bind(this);
        this.showDiv27= this.showDiv27.bind(this);
        this.showDiv28= this.showDiv28.bind(this);
        this.showDiv29= this.showDiv29.bind(this);
        this.showDiv30= this.showDiv30.bind(this);
        this.showDiv31= this.showDiv31.bind(this);

        this.state={
            showComponent26: false, /*quedas e embarcaços*/
            showComponent27: false,
            showComponent28: false,
            showComponent29: false,
            showComponent30: false,
            showComponent31: false,

            data: [
                { pergunta: "A embarcação é segura e adequada à atividade?", resposta: "Sim ou não"},
                { pergunta: "Rádio e outros equipamentos de comunicação estão a bordo e estão funcionando?", resposta: "Sim ou não"},
                { pergunta: "Os trabalhadores possuem equipamentos e roupas de proteção, como roupas de proteção térmica, colete salva-vidas ou outros dispositivos de flutuação?", resposta: "Sim ou não"},
                { pergunta: "As condições meteorológicas foram checadas antes de realizar atividades no mar?"
                    , resposta: "Sim ou não" },
                { pergunta: "Os equipamentos de segurança estão em boas condições de funcionamento?", resposta: "Sim ou não"},
                { pergunta: "Ao subir ou descer de barcos, há um corredor ou passarela adequada para evitar quedas de trabalhadores no mar?", resposta: "Sim ou não"},

            ],
        }
    }

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };

    /*** quedas e embarcaços ***/

    showDiv26 = (e) => {
        this.setState({
            showComponent26: e.target.checked,
        });
    };

    showDiv27 = (e) => {
        this.setState({
            showComponent27: e.target.checked,
        });
    };

    showDiv28 = (e) => {
        this.setState({
            showComponent28: e.target.checked,
        });
    };

    showDiv29 = (e) => {
        this.setState({
            showComponent29: e.target.checked,
        });
    };


    showDiv30 = (e) => {
        this.setState({
            showComponent30: e.target.checked,
        });
    };


    showDiv31 = (e) => {
        this.setState({
            showComponent31: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };
    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});

        return(
            <Card>

                <Row>
                    <div className={"text-center"} align="center">
                        <img src={hazard2} className={"img"} alt={"Safety and security"} width={"100"} height={"100"}/>
                    </div>
                </Row>
                <div id={"printDiv"}>

                    <div align={"center"}>
                    <h5><b><FormattedMessage id={"fall.ch"} defaultMessage={"Checklist Quedas e Embarcações"}/></b></h5>
                    </div>
                    <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>

                    <div className={"margin"}>
                        <b><FormattedMessage id={"fall.ch"} defaultMessage={"Checklist Quedas e Embarcações"}/></b></div>

                    <div className={"fall1"}>

                        <form action={"#"} className={"formsWorks"}>

                            <p><FormattedMessage id={"fall.ch1"} defaultMessage={"A embarcação é segura e adequada à atividade? "}/>           </p>

                            <input type={"checkbox"} id={"yes26"}/>

                            <label htmlFor={"yes26"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no26"} onClick={this.showDiv26}/>

                                <label htmlFor={"no26"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent26 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                        </form>
                    </div>

                    <div className={"fall2"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"fall.ch2"} defaultMessage={"Rádio e outros equipamentos de comunicação estão a bordo e estão funcionando?"}/>

                            </p>

                            <input type={"checkbox"} id={"yes27"}/>

                            <label htmlFor={"yes27"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no27"} onClick={this.showDiv27}/>

                                <label htmlFor={"no27"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent27 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"fall3"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"fall.ch3"} defaultMessage={"Os trabalhadores possuem equipamentos e roupas de proteção, como roupas de proteção térmica, colete salva-vidas ou outros dispositivos de flutuação?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes28"}/>

                            <label htmlFor={"yes28"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no28"} onClick={this.showDiv28}/>

                                <label htmlFor={"no28"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent28 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"fall4"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"fall.ch4"} defaultMessage={"As condições meteorológicas foram checadas antes de realizar atividades no mar?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes29"}/>

                            <label htmlFor={"yes29"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no29"} onClick={this.showDiv29}/>

                                <label htmlFor={"no29"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent29 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"fall5"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"fall.ch5"} defaultMessage={"Os equipamentos de segurança estão em boas condições de funcionamento?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes30"}/>

                            <label htmlFor={"yes30"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no30"} onClick={this.showDiv30}/>

                                <label htmlFor={"no30"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent30 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>

                    <div className={"fall6"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"fall.ch6"} defaultMessage={"Ao subir ou descer de barcos, há um corredor ou passarela adequada para evitar quedas de trabalhadores no mar?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes31"}/>

                            <label htmlFor={"yes31"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no31"} onClick={this.showDiv31}/>

                                <label htmlFor={"no31"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent31 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>
                </div>

                <br/>
                <Button className={"button"} onClick={this.handleDownloadPDF} >
                    PDF
                </Button>


                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                       CSV
                    </Button> </CSVLink>
            </Card>
        )}

}

export default injectIntl(ChecklistQuedas);